<template>

  <md-layout md-gutter class="main_layout">
    <md-layout md-flex="15"></md-layout>
    <md-layout  md-column md-gutter>
    <router-link to="/">
      <img src='../assets/chemistryAI_logo.png' style="height: 77px; width:265px; margin-bottom:50px;"/>
    </router-link> 
      <md-card md-with-hover class="user-form-card">
        <md-card-header>
          <div class="md-title">Please fill in the form:</div>
          <div class="md-subhead">All fields are required</div>
       </md-card-header>
       <md-card-content>
       
         <form class="user-form" v-on:submit="validateProfileForm">
    
           <md-input-container>
             <label>First Name</label>
             <md-input placeholder="First Name*" name="firstname" v-model="profile.first_name"  required></md-input>
          </md-input-container>
          <md-input-container>
            <label>Last Name</label>
            <md-input placeholder="Last Name*" name="lastname" v-model="profile.last_name" required></md-input>
          </md-input-container>
          <md-input-container>
            <label>Title</label> 
            <md-input placeholder="Title*" name="title" v-model="profile.title" required></md-input>
          </md-input-container>
          <md-input-container>
            <label>Current company</label>
            <md-input placeholder="Current company*" name="affiliation" v-model="profile.affiliation" required></md-input>
          </md-input-container>
          <md-input-container>
            <label>How do you classify yourself (e.g. organic chemist)</label>
            <md-input placeholder="How do you classify yourself (e.g. organic chemist)*" name="classify" v-model="profile.classify" required></md-input>
          </md-input-container>  
          <md-input-container>
            <label>Years of experience</label>
            <md-input type="number" placeholder="Years of experience*" name="experience" v-model="profile.experience" required></md-input>
          </md-input-container>
          <md-input-container>
            <label>Where did you do your undergraduate degree?</label>
            <md-input placeholder="Where did you do your undergraduate degree?*" name="affiliation" v-model="profile.undergraduate" required></md-input>
          </md-input-container> 
          <md-input-container>
            <label>Where did you do your graduate degree?</label>
            <md-input placeholder="Where did you do your graduate degree?*" name="affiliation" v-model="profile.graduate" required></md-input>
          </md-input-container> 
          <md-input-container>
            <label>Companies you worked for</label>
            <md-textarea maxlength="250" v-model="profile.companies" required></md-textarea>
          </md-input-container>
          <md-input-container>
            <label>Favorite target class</label>
            <md-input placeholder="Favorite target class*" name="affiliation" v-model="profile.target_class" required></md-input>
          </md-input-container> 
          <md-input-container>
            <label>Email</label>
            <md-input placeholder="Email*" name="email" type="email" v-model="profile.email"  required></md-input>
          </md-input-container> 
          
          
          <md-button class="md-raised md-primary" type="submit" style="color:#fff;">Update Profile </md-button>
         </form>
          
         
       </md-card-content>
       
       
       
     </md-card>
    
        
    <experiment-choice></experiment-choice>
    
    <experiment-passed></experiment-passed>
        
    </md-layout>
    
    <md-layout md-flex="15">
      
    </md-layout>
    
       
    
  </md-layout>
 
</template>

<script>
import ExperimentChoice from './ExperimentChoice'
import ExperimentPassed from './ExperimentPassed'

export default {
  name: 'profile',
  props: [],
  components: {
	  ExperimentChoice,
	  ExperimentPassed
    },
  data () {
    return {
    	
    }
  },
  beforeCreate() {
		this.$store.dispatch('getProfile')
		
  },

  computed: {
	  profile(){
		  
		  return this.$store.state.profile
	  }
  },
  methods: {
	  validateProfileForm: function(){
        event.preventDefault();
        this.$store.dispatch('updateProfile', {profile: this.profile})
        
      }    
    }
}
</script>

<style scoped>
.main_layout{
  padding: 50px 0 150px 0 ;

}
  h1 {
    height: 10px;
    display: block;
  }
  .userform{ 
     margin: 50px 0 50px 0;
     width: 100%;
     display: block;
  }
  .user-form-card{
     width: 80%;
     margin: 0 auto; 
  }
  .user-form{
    width: 80%;
    margin: 0 auto;
  }
</style>


// WEBPACK FOOTER //
// Profile.vue?5446d8b1